<component v-if="shouldRenderConfig" v-bind:is="getContainer">
</component>